<div class="f f-gap-5 p-t8 p-l2"><div class="t-xs gray" v-for="(option, index) in options" :key="index">{{ option }}</div></div>